import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AnswerFilter } from '../../model/search-filter/answer-filter';
import { ApplicationContext } from '../../model/application-context';
import { Question } from '../../model/question';

@Component({
    selector: 'search-filter',
    template: `
    <ul class="nav navbar-nav">
        <li [ngClass]="{'active':!appContext.searchFilters.isEmpty()}">
            <a class="hand" (click)="showFilterDialog()"> {{'searchFilter'|translate}}</a>
            <div></div>
        </li>
    </ul>

<div class="modal" [style.display]="_showAddFilterDialog ? 'inline' : 'none'">
    <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Search</h5>
              <button (click)="hideFilterDialog()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-2">
                        <label>{{'dates'|translate}}</label>
                    </div>
                    <div class="col-md-4">
                        <input type="date"  #startDate class="form-control" [(ngModel)]="appContext.searchFilters.datesFilter.startDate">
                    </div>
                    <div class="col-md-4">
                        <input type="date"  #endDate class="form-control" [(ngModel)]="appContext.searchFilters.datesFilter.endDate">
                    </div>
                    <div class="col-md-2" style="padding-left: 0px;">
                        <button type="button" class="btn btn-default btn-sm" (click)="resetDates()">
                           <span class="glyphicon glyphicon-erase" style="color:pink;" ></span> {{'erase'|translate}}
                        </button>
                    </div>
                </div>
                <div class="row" style="margin-top:20px;">
                    <div class="col-md-2">
                        <label>{{'syncho'|translate}}</label>
                    </div>
                    <div class="col-md-8">
                       <select class="form-control" [(ngModel)]="appContext.searchFilters.synchronizationFilter.synchroId">
                                 <option value="" disabled selected>Select...<span class="caret"></span></option>
                                 <option  *ngFor="let synchro of appContext.synchrosForSearch" value="{{synchro.deviceId}}" >
                                     {{synchro.time}}
                                 </option>
                         </select>
                    </div>

                    <div class="col-md-2" style="padding-left: 0px;">
                        <button type="button" class="btn btn-default btn-sm" (click)="resetSynchronization()">
                           <span class="glyphicon glyphicon-erase" style="color:pink;" ></span> {{'erase'|translate}}
                        </button>
                    </div>
                </div>
                <div *ngIf="appContext.questionnaire.email" class="row" style="margin-top:20px;">
                    <div class="col-md-2">
                        <label>{{'emailStatus'|translate}}</label>
                    </div>
                    <div class="col-md-4">
                        <select [(ngModel)]="appContext.searchFilters.emailStatusFilter.status" class="form-control">
                                <option value="" disabled selected>Select...<span class="caret"></span></option>
                                <option value="sent">Sent</option>
                                <option value="not_sent">Not sent</option>
                                <option value="opened">Opened</option>
                        </select>
                    </div>
                    <div class="col-md-4">
                    </div>
                    <div class="col-md-2" style="padding-left: 0px;">
                        <button type="button" class="btn btn-default btn-sm" (click)="resetEmail()">
                            <span class="glyphicon glyphicon-erase" style="color:pink;"></span> {{'erase'|translate}}
                            </button>
                    </div>
                </div>

                <!-- Answers filter -->
                <div *ngFor="let answerFilter of appContext.searchFilters.answersFilter let j=index" class="row" style="margin-top:20px;">
                    <div class="col-md-2">
                        <label>{{'answer'|translate}} </label>
                    </div>
                    <div class="col-md-4">
                        <select class="form-control" [(ngModel)]="answerFilter.question.no" #selectControl
                             (change)="onSelectQuestionChange(selectControl.value, answerFilter, j)">
                                 <option value="" selected>Question...<span class="caret"></span></option>
                                 <option  *ngFor="let q of appContext.questionnaire.questions" value = "{{q.no}}">
                                     {{q.texts[appContext.questionnaire.languages[0]]}}
                                 </option>
                         </select>
                          <small *ngIf = "!checkQuestionSelected(selectControl.value)"  class="text-danger"> Choise question </small>
                    </div>

                    <div  class="col-md-4" [ngSwitch]="answerFilter.question.type">
                        <ng-container *ngSwitchCase="'combo'">
                            <select class="form-control" [(ngModel)]="answerFilter.answer">
                                <option
                                   *ngFor="let choice of answerFilter.question.choices"
                                   [value]="choice.texts[appContext.questionnaire.languages[0]]"
                                   > {{choice.texts[appContext.questionnaire.languages[0]]}}
                                 </option>
                            </select>
                        </ng-container>
                        <ng-container *ngSwitchCase="'radio'">
                            <div *ngFor="let choice of  answerFilter.question.choices" class="radio">
                                <label>
                                     <input  type="radio" [value]="choice.texts[appContext.questionnaire.languages[0]]"  [(ngModel)]="answerFilter.answer">
                                                       {{choice.texts[appContext.questionnaire.languages[0]]}}
                                      </label>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'check'">
                            <div class="checkbox">
                                <label>
                                 <input type="checkbox" [(ngModel)]="answerFilter.answer">
                                       {{answerFilter.question.texts[appContext.questionnaire.languages[0]]}}
                                 </label>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <input type="text" class="form-control" #txt [(ngModel)]="answerFilter.answer" />
                            <small [hidden]="!(selectControl.value !='' && txt.value=='') " class="text-danger"> Text required </small>
                        </ng-container>
                    </div>
                    <div class="col-md-2" style="padding-left: 0px;">
                        <button *ngIf="appContext.searchFilters.answersFilter.length ==1" type="button" class="btn btn-default btn-sm" (click)="resetAnswerTest(j)">
                           <span class="glyphicon glyphicon-erase" style="color:pink;" ></span> {{'erase'|translate}}
                        </button>
                        <button type="button" class="btn btn-default btn-sm" (click)="removeFilter(j)" *ngIf="appContext.searchFilters.answersFilter.length > 1">
                           <span  class="glyphicon glyphicon-remove"   style="color:pink;" ></span> Remove
                         </button>
                    </div>
                </div>
                <div *ngIf=" appContext.searchFilters.answersFilter.length<appContext.questionnaire.questions.length" class="row" style="margin-top:20px;">
                    <div class="col-md-4">
                        <a class="btn btn-outline-primary" role="button" (click)="addFilter()">{{'add'|translate}}</a>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="resetAll()"> <span><i class="fas fa-eraser"></i></span> {{'erase'|translate}}</button>
                <button type="button" class="btn btn-primary" [disabled]="!checkSearchValid()"
                    (click)="onFilterSave()"><span><i class="fas fa-save"></i></span> {{'save'|translate}}</button>
            </div>
        </div>
    </div>
</div>
    `

})
export class SearchFilterComponent {
    @Input('app-context') appContext: ApplicationContext;
    @Output() filterChange = new EventEmitter();

    _isSearchValid = false;
    _showAddFilterDialog = false;

    addFilter() {
        this.appContext.searchFilters.addEmptyAnswerFilter();
    }
    removeFilter(index) {
        this.appContext.searchFilters.answersFilter.splice(index, 1);
    }

    onFilterSave() {
        this.filterChange.emit();
        this.hideFilterDialog();
    }

    hideFilterDialog() {
        this._showAddFilterDialog = false;
    }

    showFilterDialog() {
        this._showAddFilterDialog = true;
    }

    resetEmail() {
        this.appContext.searchFilters.emailStatusFilter.status = '';
    }

    resetSynchronization() {
        this.appContext.searchFilters.synchronizationFilter.synchroId = '';
    }

    resetDates() {
        this.appContext.searchFilters.datesFilter.endDate = 0;
        this.appContext.searchFilters.datesFilter.startDate = 0;
    }
    resetAnswerTest(index) {
        this.appContext.searchFilters.answersFilter[index] = new AnswerFilter();

    }

    resetAll() {
        this.resetEmail();
        this.resetDates();
        this.appContext.searchFilters.answersFilter.length = 0;
        this.appContext.searchFilters.answersFilter.push(new AnswerFilter());
    }

    onSelectQuestionChange(value, answerFilter, j) {
        if (value !== '') {
            answerFilter.question =
                this.getQuestionByNum(this.appContext.questionnaire.questions, value);
            const temp = [];
            for (let i = 0; i < this.appContext.searchFilters.answersFilter.length; i++) {
                temp.push(this.appContext.searchFilters.answersFilter[i].question.no);
            }
            if (this.checkDuplicatedValues(temp)) {
                this.appContext.searchFilters.answersFilter[j] = new AnswerFilter();
            }
        } else {
            this.resetAnswerTest(j);
        }

    }

    checkQuestionSelected(value): boolean {
        let  _isQuestionSelected = true;
           if (this.appContext.searchFilters.answersFilter.length > 1 && value === '') {
           _isQuestionSelected = false;
        }
        return _isQuestionSelected;
    }

    /**
    * @param listValues : liste des string
    * @return true : si il ya des doublons
    *         false : sinon
    */
    checkDuplicatedValues(listValues): boolean {
        let double = false;
        const listTempQuestion = [];
        for (let i = 0; i < listValues.length; i++) {
            listTempQuestion.push(listValues[i]);
        }
        const sorted_arr = listTempQuestion.slice().sort();
        const results = [];
        for (let i = 0; i < listTempQuestion.length - 1; i++) {
            if (sorted_arr[i + 1] === sorted_arr[i]) {
                results.push(sorted_arr[i]);
            }
        }

        if (results.length > 0) {
            double = true;
        }
        return double;
    }

    /**
     * @param questions : liste des questions
     * @param numeroQuestion : numero du question
     * @return question :Question
     */
    getQuestionByNum(questions: Question[], numeroQuestion: number): Question {
        let question;
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].no === numeroQuestion) {
                question = questions[i];
            }
        }
        return question;
    }


    /**
     * @return true  : si la liste des reponses superieure a 1 et que tous les champs sont rempli
     *         false : sinon
     */
   checkSearchValid() {
        let _isSearchValid = true;
        if (this.appContext.searchFilters.answersFilter.length > 1) {
            for (let i = 0; i < this.appContext.searchFilters.answersFilter.length; i++) {
                if (this.appContext.searchFilters.answersFilter[i].answer === '') {
                    _isSearchValid = false;
                } else {
                    _isSearchValid = true;
                }
            }
        }
        return _isSearchValid;
    }
}
